import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  datetime_from: d.startOf('day').format(),
  datetime_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'input', name: 'client_name', title: t('form.ФИО'), placeholder: t('form.ФИО'), w: 220 },
    { type: 'input', name: 'client_ncontract_numberame', title: t('filter.№ договора паркирования'), placeholder: t('filter.№ договора паркирования'), w: 220 },
    { type: 'input', name: 'mean_number', title: t('dict_filter.№ СО'), placeholder: t('dict_filter.№ СО'), w: 220 },
    {
      type: 'select',
      name: 'is_payed',
      title: t('grid.Статус оплаты'),
      items: [
        { name: t('grid.Оплачено'), value: 'payed' },
        { name: t('grid.Не оплачено'), value: 'notpayed' },
      ],
    },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'promise_payFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
